import React from "react";
import Box from "../components/common/Box";
import { makeStyles } from "@mui/styles";
import Text from "../components/common/Text";
import Grid from "components/common/Grid";
import Stack from "../components/common/Stack";
import Card from "../components/common/Card";
import CardContent from "../components/common/CardContent";
import TextField from "@mui/material/TextField";
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import InputLabel from "@mui/material/InputLabel";
import Image from "../components/common/Image";

const Myprofile = ({ onChange, formData, formError, disable }) => {
  const classes = useStyles();
  let history = useHistory();

  return (
    <Box className={classes.center} sx={{ marginTop: "2rem" }}>
      <Card>
        <CardContent>
          <Text
            variant="h5"
            color="#707070"
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            <Box
              sx={{
                fontSize: "24px",
                fontWeight: "bold",
                marginBottom: "40px",
              }}
            >
              <ArrowBackIcon
                sx={{
                  fontSize: "24px",
                  fontWeight: "bold",
                  marginRight: "10px",
                }}
                onClick={() => history.goBack()}
              />
              My Profile
            </Box>
          </Text>

          <Stack
            direction="row"
            justifyContent="space-between"
            sx={{
              marginBottom: "1.25rem",
            }}
          >
            <Grid container columnSpacing={{ xs: 0, sm: 0, md: 2, lg: 2 }}>
              <Grid item xs={2}></Grid>

              <Grid item xs={10}>
                <Box className={classes.profileImageContainer}>
                  <InputLabel disabled={disable}>
                    
                    {formData.thumbnail ? (
                      <Image
                        className={classes.profileImage}
                        src={formData.thumbnail}
                      />
                    ) : (
                      <Image
                        className={classes.profileImage}
                        src="profileimg.png"
                      />
                    )}
                  </InputLabel>
                </Box>
              </Grid>

              <Grid item xs={12} sm={12} md={2} lg={2}>
                <Text variant="body1" className={classes.formSubHeading}></Text>
                <Text variant="body1" className={classes.formHeading}>
                  PERSONAL DETAILS
                </Text>
              </Grid>
              <Grid item xs={12} sm={12} md={10} lg={10}>
                <Box className={classes.form_container}>
                  <TextField
                    fullWidth
                    size="small"
                    id="outlined-basic"
                    label="Full name"
                    disabled={disable}
                    variant="outlined"
                    error={formError.name}
                    helperText={formError.name}
                    InputLabelProps={{ style: { fontSize: 16 } }}
                    inputProps={{
                      style: { textTransform: "capitalize", fontSize: "16px" },
                    }}
                    value={formData.name}
                    onChange={(e) => onChange("name", e.target.value)}
                  />

                  <Grid
                    container
                    columnSpacing={{ xs: 0, sm: 0, md: 2, lg: 2 }}
                  >
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <TextField
                        fullWidth
                        size="small"
                        id="outlined-basic"
                        label="Email"
                        variant="outlined"
                        className={classes.form_space}
                        InputLabelProps={{ style: { fontSize: 16 } }}
                        inputProps={{ style: { fontSize: "16px" } }}
                        value={formData.email}
                        disabled={true}
                        onChange={(e) => onChange("email", e.target.value)}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                      <TextField
                        fullWidth
                        size="small"
                        id="outlined-basic"
                        label="Contact Number"
                        variant="outlined"
                        className={classes.form_space}
                        InputLabelProps={{ style: { fontSize: 16 } }}
                        inputProps={{
                          style: { fontSize: "14px" },
                          maxLength: 10,
                          minLength: 10,
                        }}
                        value={formData.contact}
                        disabled={true}
                        onChange={(e) => onChange("contact", e.target.value)}
                      />
                    </Grid>
                  </Grid>

                  <Grid
                    className={classes.form_space}
                    container
                    columnSpacing={{ xs: 0, sm: 0, md: 2, lg: 2 }}
                  ></Grid>
                </Box>
              </Grid>

              <Grid item xs={12} sm={12} md={2} lg={2}></Grid>
              <Grid item xs={12} sm={12} md={10} lg={10}>
                <Box className={classes.form_container}>
                  <Box></Box>

                  <Grid
                    container
                    columnSpacing={{ xs: 0, sm: 0, md: 2, lg: 2 }}
                  ></Grid>
                </Box>
              </Grid>

              <Grid item xs={12} sm={12} md={2} lg={2}></Grid>
              <Grid item xs={12} sm={12} md={10} lg={10}>
                <Box className={classes.form_container}></Box>
              </Grid>
            </Grid>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
};

const useStyles = makeStyles((theme) => ({
  form_space: {
    marginTop: "1.25rem",
    "@media (max-width:768px)": {
      marginTop: "1.5rem",
    },
  },

  formHeading: {
    fontSize: "16px",
    fontFamily: "Nunito Sans",
    fontWeight: "bold",
    color: "#1E1E1E",
    width: "109%",
  },

  formSubHeading: {
    fontSize: "0.75rem",
    fontFamily: "Nunito Sans",
    fontWeight: "bold",
    color: "#E9E9E9",
    marginTop: "1.6rem",
  },

  form_container: {
    padding: "1.25rem",
    width: "65%",
    marginLeft: "2%",
    "@media (max-width:768px)": {
      padding: "0.5rem",
      width: "98%",
      margin: "auto",
    },
  },

  profileImageContainer: {
    alignContent: "center",
    justifyContent: "center",
    width: "55%",
    marginLeft: "5%",
    "@media (max-width:768px)": { width: "55%" },
  },

  profileImage: {
    width: "29.5%",
    height: "8rem",
    borderRadius: "50%",
    "@media (max-width:768px)": {
      width: "100%",
      height: "9rem",
    },
  },
}));
export default Myprofile;
